import React, { useContext } from "react";

import { isViewerInstructorPerson } from "../../../auth/studentProfileAccess";
import { openSubPopup } from "../../Common/popupUIStore";
import { ReservationCardUI } from "../../UI";
import ProfileListMeta from "./ProfileListMeta";
import { StudentInfoContext } from "./StudentInfoContext";
import { useProfileAlert } from "./useProfileAlert";
import {
   fmtReservationDate,
   fmtReservationTime,
   getReservationPrimaryId,
   getReservationRowKey,
   isReservationCancelled,
   isReservationFavorite,
   isReservationImportant,
   readReservationColor,
   readReservationDisplayInstructor,
   readReservationGearbox,
   readReservationSector,
   getReservationLessonKey,
   isCurrentReservation,
} from "./studentInfoShared";

export default function StudentReservationsTab() {
   const {
      loading,
      error,
      sortedReservations,
      setReservationsAscending,
      reservationsAscending,
      reservationNumberByKey,
      fromReservationId,
      currentReservationStart,
      canOpenReservationEdit,
      maskOtherInstructors,
      viewerInstructor,
      viewerUser,
   } = useContext(StudentInfoContext);
   useProfileAlert(error);

   return (
      <>
         {loading && (
            <p className="students-info__loading">Se încarcă programările...</p>
         )}

         {!loading && !error && (
            <>
               <ProfileListMeta
                  count={sortedReservations.length}
                  one="rezervare"
                  many="rezervări"
                  ascending={reservationsAscending}
                  onToggleSort={() => setReservationsAscending((prev) => !prev)}
               />

               {sortedReservations.length === 0 && (
                  <p className="students-info__empty">Nu există programări.</p>
               )}

               {sortedReservations.length > 0 && (
                  // casetele lipite, ca grupurile din tipare (ReservationCardUI.List)
                  <ReservationCardUI.List className="studentsProfileUI__reservationsList">
                     {sortedReservations.map((reservation, index) => {
                        const start =
                           reservation?.startTime ??
                           reservation?.start ??
                           reservation?.startAt ??
                           reservation?.reservation?.startTime ??
                           null;
                        const reservationId = getReservationPrimaryId(reservation);
                        const isCancelled = isReservationCancelled(reservation);
                        const isFavorite = isReservationFavorite(reservation);
                        const isImportant = isReservationImportant(reservation);
                        const cardColor = readReservationColor(reservation);
                        // Afișăm instructorul cu care se face efectiv lecția
                        // (înlocuitorul zilei, dacă există). Un instructor
                        // vede doar propriul nume; restul apar ca „alt
                        // instructor", fără detalii despre înlocuire.
                        const displayInstructor =
                           readReservationDisplayInstructor(reservation);
                        const canShowInstructorName =
                           !maskOtherInstructors ||
                           isViewerInstructorPerson(displayInstructor.instructor, {
                              instructor: viewerInstructor,
                              user: viewerUser,
                           });
                        const instructorName = canShowInstructorName
                           ? displayInstructor.name
                           : "alt instructor";
                        const showSubstituteHint =
                           canShowInstructorName && displayInstructor.isSubstitute;
                        const reservationKey = getReservationLessonKey(reservation);
                        const reservationNumber =
                           reservationNumberByKey.get(reservationKey);
                        const isHighlightedReservation = isCurrentReservation(
                           reservation,
                           fromReservationId,
                           currentReservationStart,
                        );
                        const canOpenReservationCard =
                           canOpenReservationEdit && !!reservationId;

                        const openCard = () =>
                           openSubPopup("reservationEdit", {
                              reservationId,
                              reservationSnapshot: reservation,
                           });

                        return (
                           <ReservationCardUI
                              key={getReservationRowKey(reservation, index)}
                              color={cardColor}
                              number={reservationNumber || null}
                              current={isHighlightedReservation}
                              cancelled={isCancelled}
                              onOpen={canOpenReservationCard ? openCard : undefined}
                              date={fmtReservationDate(start)}
                              time={fmtReservationTime(start)}
                              lines={[
                                 `Cu ${instructorName}${showSubstituteHint ? " · înlocuitor" : ""}`,
                                 `${readReservationSector(reservation)} · ${readReservationGearbox(reservation)}`,
                              ]}
                              flags={
                                 isFavorite || isImportant ? (
                                    <>
                                       {isFavorite ? "⁂" : ""}
                                       {isImportant ? (isFavorite ? " ‼" : "‼") : ""}
                                    </>
                                 ) : null
                              }
                           />
                        );
                     })}
                  </ReservationCardUI.List>
               )}
            </>
         )}
      </>
   );
}
